import { useState } from "react";
import { X } from "lucide-react";
import { useCountry } from "../context/CountryContext";
import { flag } from "../lib/api";
import { Input } from "./ui/input";

export const CountryMultiSelect = ({ value, onChange }) => {
  const { countries } = useCountry();
  const [q, setQ] = useState("");
  const toggle = (c) => onChange(value.includes(c) ? value.filter((x) => x !== c) : [...value, c]);
  const shown = countries.filter((c) => c.name.toLowerCase().includes(q.toLowerCase()));
  return (
    <div className="rounded-md border" data-testid="country-multiselect">
      {value.length > 0 && (
        <div className="flex flex-wrap gap-1.5 border-b p-2">
          {value.map((c) => (
            <button type="button" key={c} onClick={() => toggle(c)} className="flex items-center gap-1 rounded bg-ink px-2 py-0.5 text-xs text-white" data-testid={`selected-country-${c}`}>
              {c}<X className="h-3 w-3" />
            </button>
          ))}
        </div>
      )}
      <Input placeholder="Search countries" value={q} onChange={(e) => setQ(e.target.value)} className="rounded-none border-0 border-b focus-visible:ring-0" data-testid="country-multiselect-search" />
      <div className="grid max-h-44 grid-cols-2 overflow-y-auto p-1 sm:grid-cols-3">
        {shown.map((c) => (
          <label key={c.code} className="flex cursor-pointer items-center gap-2 rounded px-2 py-1.5 text-sm hover:bg-muted">
            <input type="checkbox" checked={value.includes(c.code)} onChange={() => toggle(c.code)} data-testid={`ms-country-${c.code}`} className="accent-[#D94A26]" />
            <img src={flag(c.code)} alt="" className="h-3 w-4 rounded-[2px]" loading="lazy" />
            <span className="truncate">{c.name}</span>
          </label>
        ))}
      </div>
    </div>
  );
};
